import { IHAStatic } from '../interfaces/IHAStatic';
import { ILCChange } from '../interfaces/ILCChange';
import { ILCChangePreviousElectionResult } from '../interfaces/ILCChangePreviousElectionResult';
import { ILCStatic } from '../interfaces/ILCStatic';
import { LCPartyCount } from './LCPartyCount';

export class LCElectionCount {

  private readonly _lcStatic: ILCStatic;
  private readonly _lcChange: ILCChange;
  private readonly _haStatic: IHAStatic;

  private totalVotesValue = 0;
  private totalEnrolledValue = 0;

  public parties: LCPartyCount[] = [];

  constructor(lcStatic: ILCStatic, lcChange: ILCChange, haStatic: IHAStatic) {
    this._lcStatic = lcStatic;
    this._lcChange = lcChange;
    this._haStatic = haStatic;

    this.totalVotesValue = this._lcChange.parties.reduce((sum, current) => sum + current.votes, 0);
    this.totalEnrolledValue = this._haStatic.districts.reduce((sum, current) => sum + current.districtEnrolled, 0);
    this._lcStatic.parties.forEach(party => {
      const lcChangeParty = lcChange.parties.find(x => x.id === party.id);
      if (lcChangeParty) {
        this.parties.push(new LCPartyCount(party, lcChangeParty, this.totalVotesValue));
      }
    });
    this.afterInit();
  }

  public afterInit(): void {
    this.parties.forEach(party => party.afterInit());

    // calc totals here
  }

  public get seatsContested(): number {
    return this._lcStatic.lcSeatsContested;
  }

  public get totalVotes(): number {
    return this.totalVotesValue;
  }

  public get totalEnrolled(): number {
    return this.totalEnrolledValue;
  }

  public get totalPBCounted(): number {
    return this._lcChange.pollingPlacesCounted;
  }

  public get totalPB(): number {
    return this._lcChange.totalPollingPlaces;
  }

  public get pbCountedPercent() {
    return this.totalPB > 0 ? (this.totalPBCounted / this.totalPB) * 100 : 0;
  }

  public get votesCast(): number {
    return this._lcChange.totalFormalVotes + this._lcChange.totalInformalVotes;
  }

  public get formalVotes(): number {
    return this._lcChange.totalFormalVotes;
  }

  public get formalVotesPercent(): number {
    return this.votesCast > 0 ? (this.formalVotes / this.votesCast) * 100 : 0;
  }

  public get informalVotes(): number {
    return this._lcChange.totalInformalVotes;
  }

  public get informalVotesPercent(): number {
    return this.votesCast > 0 ? (this.informalVotes / this.votesCast) * 100 : 0;
  }

  public get countedPercent(): number {
    return this.totalEnrolled > 0 ? (this.votesCast / this.totalEnrolled) * 100 : 0;
  }

  public get previousElectionResult(): ILCChangePreviousElectionResult {
    return this._lcChange.previousElectionResults;
  }

  public get electionYear(): string {
    return this._lcChange.electionDate.getFullYear().toString();
  }

  public get quotaVotes(): number | null{
    return this._lcChange.totalFormalVotes > 0 ? (this._lcChange.totalFormalVotes / (this.seatsContested + 1)) + 1 : null;
  }

}
